import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import ModelToggleMixin from 'quasar/src/mixins/model-toggle.js';
export default Vue.extend({
  name: 'QPdfviewer',
  mixins: [ModelToggleMixin],
  props: {
    src: String,
    type: {
      type: String,
      default: 'html5',
      validator: function validator(v) {
        return ['html5', 'pdfjs'].indexOf(v) !== -1;
      }
    },
    errorString: {
      type: String,
      default: 'This browser does not support PDFs. Download the PDF to view it:'
    },
    contentStyle: [String, Object, Array],
    contentClass: [String, Object, Array],
    innerContentStyle: [String, Object, Array],
    innerContentClass: [String, Object, Array]
  },
  data: function data() {
    return {
      hashId: 'q-pdfviewer-' + Math.random().toString(36).substr(2, 9)
    };
  },
  methods: {
    __renderObject: function __renderObject(h) {
      return h('object', {
        class: this.innerContentClass,
        style: this.innerContentStyle,
        attrs: {
          id: this.hashId,
          data: this.src,
          type: 'application/pdf',
          width: '100%',
          height: '100%'
        },
        on: _objectSpread({}, this.$listeners)
      }, [// browser object not supported, try iframe
      this.__renderIFrame(h)]);
    },
    __renderIFrame: function __renderIFrame(h) {
      return h('iframe', {
        staticClass: 'q-pdfviewer__iframe',
        attrs: {
          src: this.src,
          width: '100%',
          height: '100%'
        }
      }, [// iframe not supported either, give user a link to download
      this.__renderText(h)]);
    },
    __renderIFramePDFJS: function __renderIFramePDFJS(h) {
      return h('iframe', {
        staticClass: 'q-pdfviewer__iframe',
        attrs: {
          src: 'pdfjs/web/viewer.html?file=' + this.src
        }
      }, [// iframe not supported either, give user a link to download
      this.__renderText(h)]);
    },
    __renderText: function __renderText(h) {
      // TODO: ????
      return h('p', 'This browser does not support PDFs. Download the PDF to view it:', [h('a', {
        attrs: {
          href: this.src,
          target: '_blank'
        }
      })]);
    }
  },
  render: function render(h) {
    if (this.value === true && this.src !== void 0 && this.src.length > 0) {
      return h('div', {
        staticClass: 'q-pdfviewer',
        class: this.contentClass,
        style: this.contentStyle
      }, [this.$q.platform.is.electron || this.type === 'pdfjs' ? this.__renderIFramePDFJS(h) : this.__renderObject(h)]);
    }

    return '';
  }
});